(function (ws) {
    'use strict';
    ws.views.recentresellers = ws.views.simpleTable.extend({

        /**
         * Constructor
         */
        initialize: function () {
            this.$table = this.$('#recent-crl-reseller-table');
            this.rowTemplate = this.$('#crl-reseller-table-row');

            this.searchHeaderTitle = this.$('.searchHeaderTitle');

            this.controlColumn = 0;

            this.$selectedCountry = '';
            this.$selectedLanguage = '';
            this.$selectedCurrency = '';

            this.responsivePriority = [
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 1},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2},
                {responsivePriority: 2}
            ];
            ws.views.simpleTable.prototype.initialize.call(this);
            this.searchHeaderTitle.hide();
            this.$selectedCountry = $('[name=crl-country]').val();
        },

        events: {
            'click [data-switch-resellerid]': 'switchStore'
        },

        /**
         * Switch store to a selected reseller
         * @param {Object} ev - Event object
         */
        switchStore: function (ev) {
            ev.preventDefault();
            const $el = $(ev.currentTarget);
            const hasBlockMessage = $el.data('blockmessage');
            let target = $(ev.target).closest('tr');

            dataLayerAA.reseller = {};
            dataLayerAA.reseller.id = target.data('id');
            dataLayerAA.reseller.name = target.data('name');
            dataLayerAA.reseller.currency = target.data('currency');
            dataLayerAA.reseller.salesOrg = target.data('sales-org');
            _satellite.track('event:selectReseller');

            let url = globals.path.api.westcon.switchStore +
                '?userGroupId=' + $el.data('switch-resellerid') +
                '&code=' + $el.data('switch-salesorg') +
                '&language=' + this.$selectedLanguage +
                '&currency=' + this.$selectedCurrency;

            if (hasBlockMessage) {
                this.eventAgg.trigger('qut-sap-block-msg-modal');
                $('.qut-sap-block-msg-continue').attr('href', url);
            } else {
                window.location.href = url;
            }
        }
    });

}(westcon));
